<style lang='less' scoped>
.main {
  width: 100%;
  height: 100%;
  padding: 18px;
  box-sizing: border-box;
  background: #f3f3f3;
  position: relative;
  .tips {
    width: 420px;
    height: 150px;
    position: absolute;
    background: #fff;
    z-index: 99;
    line-height: 36px;
    top: 50%;
    left: 50%;
    font-size: 14px;
    transform: translate(-50%, -50%);
    p {
      font-size: 24px;
    }
    .cancel {
      position: absolute;
      bottom: 24px;
      background: #fff;
      color: rgb(88, 88, 88);
      right: 80px;
    }
    .sure {
      position: absolute;
      bottom: 24px;
      right: 10px;
    }
  }
  .edit-teacher {
    width: 680px;
    height: auto;
    position: absolute;
    background: #fff;
    z-index: 99;
    line-height: 36px;
    top: 50%;
    left: 50%;
    font-size: 14px;
    transform: translate(-50%, -50%);
    border: 1px #c9c9c9 solid;
    padding: 12px 24px;
    box-sizing: border-box;
    .edit-btn {
      width: 100%;
      height: 48px;
      margin-top: 12px;
      position: relative;
      .cancel {
        position: absolute;
        bottom: 12px;
        background: #fff;
        color: rgb(88, 88, 88);
        right: 80px;
      }
      .sure {
        position: absolute;
        bottom: 12px;
        right: 10px;
      }
    }
    .header {
      width: 100%;
      margin-top: 12px;
      .introduce {
        width: 120px;
        height: 100%;
        span {
          color: rgb(241, 33, 33);
        }
      }
    }
  }
  .header {
    position: relative;
    width: 100%;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    height: 48px;
    background: #fff;
    padding: 9px 10px;
    box-sizing: border-box;
    display: flex;
    .loginButton {
      width: 50px;
      height: 30px;
    }
    .search {
      position: absolute;
      width: 360px;
      height: 30px;
      display: flex;
      right: 10px;
    }
  }
  .content {
    width: 100%;
    height: 100%;
    background: #fff;
    padding: 0 10px;
    box-sizing: border-box;
  }
  .footer {
    position: relative;
    height: 144px;
    width: 100%;
    background: #fff;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    padding: 48px 10px;
    box-sizing: border-box;
  }
  .create-new {
    background: #fff;
    border-radius: 8px;
    width: 100%;
    height: 600px;
    padding: 0 16px;
    box-sizing: border-box;
    z-index: 9999;
    .header {
      width: 100%;
      height: 48px;
      display: flex;
      line-height: 36px;
      font-weight: 600;
      .back {
        width: 72px;
        height: 48px;
      }
      .message {
        width: 98px;
        height: 48px;
        text-align: center;
      }
    }
    .content {
      width: 100%;
      height: 400px;
      margin-top: 20px;
      .tab-tips {
        width: 100%;
        height: auto;
        font-size: 16px;
        line-height: 48px;
        display: flex;
        margin-bottom: 20px;
        .introduce {
          width: 120px;
          height: 100%;
          span {
            color: rgb(241, 33, 33);
          }
        }
      }
      .upLoadPic {
        margin-top: 20px;
        width: 100%;
        line-height: 48px;
        display: flex;
        .introduce {
          width: 120px !important;
          font-size: 16px;
          height: 100%;
          span {
            color: rgb(241, 33, 33);
          }
        }
      }
    }
  }
}
</style>
<style lang='less'>
.search {
  .ivu-input-icon-clear {
    display: none;
    right: 70px;
  }
}
</style>
<style lang="less">
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .info-list {
    position: relative;
    margin-top: 8px;
    width: 100%;
    height: 40px;
    display: flex;
    line-height: 30px;
    .introduce {
      width: 100px;
      line-height: 30px;
      span {
        color: rgb(241, 33, 33);
      }
    }
  }
  .upLoadPic {
    margin-top: 20px;
    width: 100%;
    line-height: 48px;
    display: flex;
    .introduce {
      width: 100px !important;
      font-size: 12px;
      height: 100%;
      span {
        color: rgb(241, 33, 33);
      }
    }
  }
  .ivu-modal {
    top: 0;
  }
}
</style>
<template>
  <div class="main">
    <div v-show="newUser">
      <div class="header">
        <i-button
          type="primary"
          @click="AddNew"
        >新增</i-button>
        <div class="search">
          <Select
            v-model="statusKey"
            placeholder="请选择状态"
            @on-change="GetClass"
            filterable
            clearable
            style="width:120px;margin-right: 16px;"
          >
            <Option
              v-for="(item,index) in statusList"
              :key="index"
              :value="item.value"
            >{{ item.label }}</Option>
          </Select>
          <Input
            @on-search="GetClass"
            @on-change="GetClass"
            v-model="userId"
            clearable
            search
            enter-button="搜索"
            placeholder="输入老师姓名或手机号"
            style="width:360px;"
          />
        </div>
      </div>
      <div class="content">
        <i-table
          border
          :columns="classColumns"
          :data="showList"
        />
        <Modal
          :title="`班级名称:${invitationName}`"
          v-model="invitationPopup"
          class-name="vertical-center-modal"
        >
          <p>方法一：可截屏后发送学生微信扫码加入班级</p>
          <div
            id="qrCode"
            style="margin-top:16px;margin-bottom:16px;margin-left: 30px;"
            ref="qrCodeDiv"
          />
          <p>方法二：复制链接https://cwap.qupeiyin.cn/addOrgan/addClass?group={{this.invitationId}}&code={{this.invitationCode}}</p>
          <i-button
            class="loginButton"
            style="margin-top:16px;margin-bottom:16px;"
            v-clipboard:copy="messageCopy"
            v-clipboard:success="OnCopy"
            v-clipboard:error="OnError"
          >复制链接</i-button>
          <!-- <i-button type="primary" class="loginButton" @click="AddNew">新增</i-button> -->
        </Modal>
        <Modal
          title="提示"
          v-model="edit"
          @on-ok="ChangeClass"
          class-name="vertical-center-modal"
        >
          <div class="info-list">
            <div class="introduce">
              <span>*</span>班级名称
            </div>
            <Input
              v-model="showClassName"
              :placeholder="showClassName"
              style="width:360px;"
            />
          </div>
          <div class="info-list">
            <div class="introduce">
              <span>*</span>班级邀请码
            </div>
            <Input
              disabled
              :placeholder="editCode"
              style="width:360px;"
            />
          </div>
          <div class="info-list">
            <div class="introduce">
              <span>*</span>关联教师名称
            </div>
            <Select
              v-model="model1"
              :placeholder="editAboutTeacher"
              filterable
              style="width:360px"
            >
              <Option
                v-for="(item,index) in teacherList"
                :key="index"
                v-bind:value="item.uid"
              >{{item.name}}</Option>
            </Select>
          </div>
          <div class="info-list">
            <div class="introduce">
              <span>&nbsp;&nbsp;</span>关联管理员名称
            </div>
            <Select
              v-model="model2"
              :placeholder="editAboutAdmin"
              filterable
              multiple
              style="width:360px"
            >
              <Option
                v-for="(item,index) in mannerList"
                :key="index"
                v-bind:value="item.uid"
              >{{ item.name }}</Option>
            </Select>
          </div>
          <div class="info-list">
            <div style="width: 120px;height: 24px;line-height: 24px">
              <span>&nbsp;&nbsp;</span>是否允许新学生加入
            </div>
            <i-switch
              v-model="switchStatus"
              @on-change="ChangeMyChoose"
            />
          </div>
          <div class="upLoadPic">
            <div class="introduce">
              <span>&nbsp;</span>机构二维码
            </div>
            <Upload
              type="drag"
              class="uploadMyFile"
              show-upload-list
              :before-upload="AddQrCode"
              accept=".jpg, .jpeg, .png"
              action
            >
              <div style="width: 240px !important;">
                <Icon
                  type="ios-cloud-upload"
                  on-preview="true"
                  size="52"
                  style="color: #3399ff;width: 240px !important;"
                />
                <p>单击或拖动文件以上传</p>
              </div>
            </Upload>
            <img
              :src="editCodeUrl"
              alt
              style="width: 100px;height:100px;margin-left: 10px;"
            >
          </div>
          <div class="info-list">
            <div class="introduce">
              <span>&nbsp;</span>班级联系方式
            </div>
            <Input
              v-model="editClassPhone"
              :placeholder="editClassPhone"
              style="width:360px;"
            />
          </div>
          <div class="info-list">
            <div class="introduce">
              <span>&nbsp;</span>班级联系地址
            </div>
            <Input
              v-model="editClassAddress"
              :placeholder="editClassAddress"
              style="width:360px;"
            />
          </div>
        </Modal>
        <Modal
          title="提示"
          v-model="popup"
          @on-ok="DeleteTeacher"
          class-name="vertical-center-modal"
        >
          <p>此操作将禁用班级，班级中的学生和教师都无法看到班级信息，是否继续？</p>
        </Modal>
      </div>
      <div class="footer">
        <Page
          :total="count"
          :page-size="pageSize"
          :page-size-opts="[10,20]"
          show-total
          @on-change="ChangePage"
          @on-page-size-change="ChangePageSize"
          show-elevator
          show-sizer
        />
      </div>
    </div>
    <div v-show="!newUser">
      <div class="create-new">
        <div class="header">
          <Button
            @click="Reback"
            type="primary"
            style="height: 36px;"
          >
            <Icon type="ios-arrow-back" />返回
          </Button>
          <div class="message">新增班级</div>
        </div>
        <div class="content">
          <div class="tab-tips">
            <div class="introduce">
              <span>*</span>班级名称
            </div>
            <Input
              v-model="newClassName"
              placeholder="请输入班级名称"
              style="width:360px;margin-top:8px;"
            />
          </div>
          <div class="tab-tips">
            <div class="introduce">
              <span>*</span>关联教师
            </div>
            <Select
              v-model="newClassTeacher"
              filterable
              style="width:360px;margin-top:8px;"
            >
              <Option
                v-for="(item,index) in teacherList"
                :key="index"
                v-bind:value="item.uid"
              >{{ item.name }}</Option>
            </Select>
          </div>
          <div class="tab-tips">
            <div class="introduce">
              <span>&nbsp;</span>关联管理员
            </div>
            <Select
              v-model="newClassAdmin"
              filterable
              multiple
              style="width:360px;margin-top:8px;"
            >
              <Option
                v-for="(item,index) in mannerList"
                :key="index"
                v-bind:value="item.uid"
              >{{ item.name }}</Option>
            </Select>
          </div>
          <div class="tab-tips">
            <div style="width: 160px;height:24px;line-height: 24px;">
              <span>&nbsp;</span>是否允许新学生加入
            </div>
            <i-switch
              v-model="newSwitch"
              @on-change="CreatNewSwith"
            />
          </div>
          <div class="upLoadPic">
            <div class="introduce">
              <span>&nbsp;</span>班级二维码
            </div>
            <Upload
              type="drag"
              class="uploadMyFile"
              show-upload-list
              :before-upload="AddNewQrCode"
              accept=".jpg, .jpeg, .png"
              action
            >
              <div style="width: 240px !important;">
                <Icon
                  type="ios-cloud-upload"
                  on-preview="true"
                  size="52"
                  style="color: #3399ff;width: 240px !important;"
                />
                <p>单击或拖动文件以上传</p>
              </div>
            </Upload>
            <img
              :src="newCodeUrl"
              alt
              style="width: 100px;height:100px;margin-left: 10px;"
            >
          </div>
          <div class="tab-tips">
            <div class="introduce">
              <span>&nbsp;</span>班级联系方式
            </div>
            <Input
              v-model="newClassPhone"
              placeholder="请输入联系方式"
              style="width:360px;margin-top:8px;"
            />
          </div>
          <div class="tab-tips">
            <div class="introduce">
              <span>&nbsp;</span>班级联系地址
            </div>
            <Input
              v-model="newClassAddress"
              placeholder="请输入联系地址"
              style="width:360px;margin-top:8px;"
            />
          </div>
          <div class="tab-tips">
            <div class="introduce" />
            <i-button
              type="primary"
              class="creatButton"
              @click="CreatNewClass"
            >确定</i-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import schoolApi from '@/lib/api/school'
import analysisApi from '@/lib/api/analysis'
import utilsTool from '@lib/utils'
import QRCode from 'qrcodejs2'
export default {
  name: '',
  data() {
    return {
      messageCopy: '',
      userId: '', // 搜索关键字
      newUser: true,
      edit: false,
      popup: false,
      newSwitch: true,
      switchStatus: true,
      invitationPopup: false,
      isAllow: '',
      allowNew: '',
      model1: '',
      model2: [],
      list: 6,
      count: 0,
      showList: [],
      teacherList: [], // 教师列表
      mannerList: [], // 管理员列表
      picList: [],
      picUrlList: [],
      start: 0,
      pageSize: 10,
      selected: '',
      showClassName: '', // 编辑时展示原班级名称
      forbidId: '', // 禁用班级id
      editClassName: '', // 编辑班级名称
      editTeacher: '', // 编辑班级教师
      editAdmin: '', // 编辑班级管理员
      newClassTeacher: '', // 新建班级关联教师
      newClassName: '', // 新建班级名称
      newClassPhone: '', // 新建班级联系方式
      newClassAddress: '', // 新建班级地址
      newCodeUrl: '', // 新建班级的二维码
      newClassAdmin: [], // 关联管理员
      editClassID: '', // 被编辑班级的ID
      editAboutTeacher: '', // 编辑班级相关管理员
      editAboutAdmin: '', // 被编辑班级相关管理员
      invitationId: '', // 邀请时的班级id
      invitationCode: '', // 班级邀请码
      invitationName: '', // 邀请班级名称
      editCode: '', // 编辑需要带过来展示仅仅是展示没什么卵用的班级邀请码
      editCodeUrl: '', // 编辑时的班级二维码
      editClassPhone: '', // 编辑的班级联系方式
      editClassAddress: '', // 编辑的班级地址
      qrCodePic: '',
      classColumns: [
        {
          title: 'ID',
          key: 'id'
        },
        {
          title: '班级名称',
          key: 'name'
        },
        {
          title: '教师姓名',
          key: 'teacher_name'
        },
        {
          title: '班级管理员',
          key: 'group_admin_name'
        },
        {
          title: '班级学生（人）',
          key: 'cur_num'
        },
        {
          title: '班级邀请码',
          key: 'code'
        },
        {
          title: '管理员操作',
          key: 'action',
          width: 240,
          align: 'center',
          render: (h, params) => {
            const invitation = h(
              'i-button',
              {
                on: {
                  click: () => {
                    this.InvitationStudent(
                      params.row.id,
                      params.row.code,
                      params.row.name
                    )
                  }
                },
                props: {
                  type: 'primary'
                }
              },
              '邀请'
            )
            const editBtn = h(
              'i-button',
              {
                on: {
                  click: () => {
                    this.EditClass({
                      id: params.row.id,
                      name: params.row.name,
                      teacher: params.row.teacher_name,
                      admin: params.row.group_admin_name,
                      teacherId: params.row.uid,
                      adminId: params.row.group_admin_uids,
                      code: params.row.code,
                      allow: params.row.is_allow,
                      qrcode: params.row.contact_qrcode,
                      classPhone: params.row.contact_mobile,
                      classAddress: params.row.contact_address
                    })
                  }
                },
                props: {
                  type: 'primary'
                }
              },
              '编辑'
            )
            const forbidBtn = h(
              'i-button',
              {
                on: {
                  click: () => {
                    this.Prohibit(params.row.id)
                  }
                },
                props: {
                  type: 'primary'
                },
                style: {
                  background: '#e6f9fa',
                  border: '1px #2f9eff solid',
                  color: '#2f9eff'
                }
              },
              '禁用'
            )
            const startBtn = h(
              'Button',
              {
                on: {
                  click: () => {
                    this.StartUse(params.row.id)
                  }
                },
                style: {
                  background: '#fff',
                  border: '1px #2f9eff solid',
                  color: '#2f9eff'
                }
              },
              '启用'
            )
            const emptyBox = h('div', {
              style: {
                width: '10px'
              }
            })
            if (params.row.status == 1) {
              return h(
                'div',
                {
                  style: {
                    display: 'flex'
                  }
                },
                [invitation, emptyBox, editBtn, emptyBox, forbidBtn]
              )
            } else if (params.row.status == 2) {
              return h(
                'div',
                {
                  style: {
                    display: 'flex'
                  }
                },
                [invitation, emptyBox, editBtn, emptyBox, startBtn]
              )
            }
          }
        }
      ],
      qrCodeInstance: null,
      // status 1，正常，2，禁用，默认不传或者传0
      statusList: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: '正常'
        },
        {
          value: 2,
          label: '禁用'
        }
      ],
      statusKey: 0
    }
  },
  created() {
    this.GetClass()
    this.GetTeacherList()
    this.GetManner()
  },
  mounted() {
    this.qrCodeInstance = new QRCode(this.$refs.qrCodeDiv, {
      text: '',
      width: 120,
      height: 120,
      colorDark: '#333333', // 二维码颜色
      colorLight: '#ffffff', // 二维码背景色
      correctLevel: QRCode.CorrectLevel.L // 容错率，L/M/H
    })
  },
  methods: {
    ChangeMyChoose() {
      if (this.switchStatus == false) {
        this.isAllow = 1
      } else {
        this.isAllow = 0
      }
    },
    CreatNewSwith() {
      if (this.newSwitch == false) {
        this.allowNew = 1
      } else {
        this.allowNew = 0
      }
    },
    OnCopy: function(e) {
      this.$Message.info('复制成功')
    },
    OnError: function(e) {
      // console.log('无法复制文本！')
    },
    // 新增班级
    AddNew() {
      this.newUser = false
    },
    // 生成二维码
    BindQRCode: function() {
      this.qrCodeInstance.makeCode(
        `https://cwap.qupeiyin.cn/addOrgan/addClass?group=${this.invitationId}&code=${this.invitationCode}`
      )
    },
    // 邀请
    InvitationStudent(id, code, name) {
      this.invitationId = id
      this.invitationCode = code
      this.invitationName = name
      console.log(this.invitationId)
      console.log(this.invitationCode)
      this.messageCopy = `https://cwap.qupeiyin.cn/addOrgan/addClass?group=${this.invitationId}&code=${this.invitationCode}`
      // var ewCode = document.getElementById("qrCode")
      this.BindQRCode()
      this.invitationPopup = true
    },
    Reback() {
      this.newUser = true
    },
    ChangePage(index) {
      this.start = (index - 1) * this.pageSize
      this.GetClass()
    },
    ChangePageSize(pageSize) {
      this.pageSize = pageSize
      this.GetClass()
    },
    // 取消编辑
    Nodel() {
      this.edit = false
      this.popup = false
    },
    // 确认编辑班级
    ChangeClass() {
      if (this.switchStatus == false) {
        this.isAllow = 1
      } else {
        this.isAllow = 0
      }
      if (this.model1 == '') {
        this.$Message.info('请填写关联教师')
      }
      if (this.model2.length == 0) {
        this.model2 = []
      }
      schoolApi
        .EditClass({
          id: this.editClassID,
          name: this.showClassName,
          teacherId: this.model1,
          adminId: this.model2.join(','),
          isAllow: this.isAllow,
          classQrCode: this.editCodeUrl,
          classMobile: this.editClassPhone,
          classAddress: this.editClassAddress
        })
        .then(res => {
          if (res.status == 1) {
            this.edit = false
            this.editClassID = ''
            this.editClassName = ''
            this.editCodeUrl = ''
            this.editClassPhone = ''
            this.model1 = ''
            this.model2 = []
            this.GetClass()
            this.$Message.info('修改成功')
          } else {
            alert(res.msg)
          }
        })
    },

    // 禁用按钮
    Prohibit(id) {
      this.forbidId = id
      this.popup = true
    },
    DeleteTeacher() {
      schoolApi
        .StartClass({
          id: this.forbidId,
          status: 2
        })
        .then(result => {
          this.popup = false
          this.GetClass()
          if (result.status == 1) {
            this.$Message.info('设置成功')
          }
        })
    },
    // 启用按钮
    StartUse(id) {
      schoolApi
        .StartClass({
          id: id,
          status: 1
        })
        .then(result => {
          this.popup = false
          if (result.status == 1) {
            this.$Message.info('设置成功')
          }
          this.GetClass()
        })
    },
    // 编辑班级
    EditClass({
      id,
      name,
      teacher,
      admin,
      teacherId,
      adminId,
      code,
      allow,
      qrcode,
      classPhone,
      classAddress
    }) {
      if (allow == 1) {
        this.switchStatus = false
      } else {
        this.switchStatus = true
      }
      this.GetClass()
      console.log(qrcode)
      console.log(classPhone)
      this.edit = true
      this.editCode = code
      this.editClassID = id
      this.showClassName = name
      this.editCodeUrl = qrcode
      this.qrCodePic = qrcode
      this.editClassPhone = classPhone
      this.editClassAddress = classAddress
      this.editAboutTeacher = teacher
      this.model1 = teacherId
      if (this.adminId == '') {
        this.model2 = []
      } else {
        const model22 = adminId
        this.model2 = model22.split(',')
      }
      console.log(this.model2)
      this.editAboutAdmin = admin
    },
    // 新建班级
    CreatNewClass() {
      if (this.newSwitch == false) {
        this.allowNew = 1
      } else {
        this.allowNew = 0
      }
      if (this.newClassName == '') {
        alert('班级名称不能为空')
      } else if (this.newClassTeacher == '') {
        alert('关联教师不能为空')
      } else {
        schoolApi
          .CreateClass({
            name: this.newClassName,
            teacherId: this.newClassTeacher,
            adminId: this.newClassAdmin.join(','),
            isAllow: this.allowNew,
            classQrCode: this.newCodeUrl,
            classMobile: this.newClassPhone,
            classAddress: this.newClassAddress
          })
          .then(res => {
            if (res.status == 1) {
              this.$Message.info('添加成功')
              this.newUser = true
              this.newClassName = ''
              this.newClassTeacher = ''
              this.newCodeUrl = ''
              this.newClassPhone = ''
              this.newClassAdmin = []
              this.GetClass()
            } else {
              alert(res.msg)
            }
          })
      }
    },
    GetClass() {
      schoolApi
        .GetClassList({
          keyword: this.userId,
          status: this.statusKey,
          start: this.start,
          rows: this.pageSize
        })
        .then(res => {
          const classInfo = res
          this.list = classInfo.data.list // 所有数据
          this.count = classInfo.data.count // 总条数
          this.showList = this.list
        })
    },
    // 获取教师列表
    GetTeacherList() {
      analysisApi
        .GetTeacherList({
          start: 0,
          rows: 500
        })
        .then(res => {
          const teacherData = res
          this.teacherList = teacherData.data.list // 教师列表
        })
    },
    // 获取管理员列表
    GetManner() {
      schoolApi
        .GetAdminList({
          start: 0,
          rows: 500,
          type: 2
        })
        .then(res => {
          const adminData = res
          this.mannerList = adminData.data.list // 所有数据
        })
    },
    AddQrCode(file) {
      utilsTool.UploadPic({
        file,
        success: res => {
          this.picList.push(file)
          this.picUrlList.push({
            name: res.fileName,
            url: res.url
          })
          console.log(this.picUrlList)
          this.editCodeUrl = res.url
          // this.ChangeClass()
          this.$Message.info('上传成功')
        },
        fail: err => {
          this.$Message.info(err)
        }
      })
      return false
    },
    AddNewQrCode(file) {
      utilsTool.UploadPic({
        file,
        success: res => {
          const data = res
          this.newCodeUrl = data.url
          // this.$Message.info("上传成功")
        },
        fail: err => {
          this.$Message.info(err)
        }
      })
      return false
    }
  }
}
</script>
